/* ============================================================
   GOLDEN STAR JEWELLERY — NIVODA CARD DESTINATION (JS)
   File: assets/gsj-nivoda-link.js

   JS mirror of snippets/gsj-nivoda-link.liquid, for the card
   surfaces that are built in the browser rather than in Liquid:
     • the recently-viewed strips (gsj-collection-grid /
       gsj-search-grid), fed from /products/{handle}.js
     • the cart drawer upsell slider (gs-panels.js)

   Scope note — deliberate, not an oversight:
   Shopify's product JSON endpoints do NOT expose metafields, so
   this cannot read nivoda.nivodaId and therefore cannot build a
   stone URL. Settings are fully handled (tag + type + variant id
   are all present). Stones fall back to their normal product URL,
   which is exactly what the Liquid helper does when a UUID is
   missing — a correct link, never a broken one.

   Safe to include more than once.
   ============================================================ */
(function (w) {
  'use strict';
  if (w.GSJNivoda) return;

  function tagList(p) {
    var t = (p && p.tags) || [];
    if (typeof t === 'string') t = t.split(',');
    return t.map(function (x) { return String(x).trim().toLowerCase(); });
  }

  function typeOf(p) {
    return String((p && (p.type || p.product_type)) || '').trim().toLowerCase();
  }

  function isBuilderOnly(p) {
    return tagList(p).indexOf('builder-only') !== -1;
  }

  /* A Nivoda ring mounting: the thing that must never reach the cart
     from a card, because on its own it is a ring with no diamond. */
  function isSetting(p) {
    return isBuilderOnly(p) && typeOf(p) === 'setting';
  }

  function firstVariantId(p) {
    var vs = (p && p.variants) || [];
    for (var i = 0; i < vs.length; i++) { if (vs[i] && vs[i].available) return vs[i].id; }
    return vs[0] && vs[0].id;
  }

  /* Returns the builder URL for a setting, or null to mean
     "leave whatever link you already had". */
  function builderUrl(p) {
    if (!isSetting(p)) return null;
    var vid = firstVariantId(p);
    return '/pages/customised-engagement-ring?stage=Select+Setting&isSWS=true&id=' +
      encodeURIComponent(p.id) + (vid ? '&variant=' + encodeURIComponent(vid) : '');
  }

  function hrefFor(p, fallback) {
    return builderUrl(p) || fallback || (p && p.handle ? '/products/' + p.handle : '#');
  }

  w.GSJNivoda = {
    isBuilderOnly: isBuilderOnly,
    isSetting: isSetting,
    builderUrl: builderUrl,
    hrefFor: hrefFor
  };
})(window);
